// src/InputField.js
import {
	Autocomplete,
	Box,
	IconButton,
	InputAdornment,
	styled,
	TextField,
	Tooltip,
	tooltipClasses,
	TooltipProps,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import React, {useEffect, useRef, useState} from 'react';
import styles from './ChatBotComponent.module.css';
import FileAttach from './../../Assets/Images/fileattachment.png';
import MessageSent from './../../Assets/Images/messagesent1.png';
import eventEmitter from './EventEmitter';
import {
	restrictedUsers,
	TOPLINE_AUTO_SUGGESTIONS_WHAT,
	TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT,
	// SPEND_WISE_SUGGESTIONS,
} from '../../Common/Constants';
import moreoptions from '../../Assets/Images/moreoptions.png';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {callLogEvent, getFileSizeInMB, Item} from '../../Common/Util';
import SpeechToText from './SpeechToText';
import {uploadFile} from '../../Services/chat-bot-service';


const useStyles = makeStyles({
	root: {},
	autoTextfield: {
		border: 'none',
		boxShadow: 'none !important',
		minWidth: '300px',
		// maxWidth: '600px',
		'& input': {
			position: 'relative',
		},
	},
	menuStyles: {
		'& .MuiMenuItem-root': {
			margin: '5px',
			border: '1px solid rgba(0, 0, 0, 0.12)',
			borderRadius: '5px',
			fontSize: '10px',
		},
	},
	moreOptions: {
		display: 'inline-block',
	},
});

const formatMonth = (ym: string) => {
  if (!ym) return "";
  const [year, month] = ym.split('_');
  const date = new Date(parseInt(year), parseInt(month) - 1);
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};
const InputField = ({
	onSend,
	onEnter,
	isIdeal,
	inputValue,
	setInputValue,
	hidden = false,
	handleDocId,
	pageTitle,
}: any) => {
	const [options, setOptions] = useState<any>([]);
	const autocompleteRef = useRef<any>(null);
	const [showSuccess, setShowSuccess] = useState(false);
	const [showError, setShowError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [draftValue, setDraftValue] = useState(inputValue || '');
	const [placeholderMessage, setPlaceholderMessage] = useState(
		'Type Your Question...'
	);

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	// const [counter, setCounter] = useState(0);
  

	const classes = useStyles();

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
		callLogEvent(
			'CLICKED_ON_NEW_DAILOG_CATBOX_MORE_OPTIONS_BUTTON',
			'clicked on more options button for chatbox'
		);
		// handlePlaceHolderMessage();
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

  
	useEffect(() => {
		if (!isIdeal) {
			setPlaceholderMessage('Loading search results');
		} else {
			setPlaceholderMessage('Type Your Question...');
		}
	}, [isIdeal]);

	// useEffect(() => {
	// 	let intervalId: any = null;

	// 	if (!isIdeal) {
	// 		// Pick a random variation set from the constants
	// 		const randomVariationKey = `Variation ${Math.floor(Math.random() * 4) + 1}`;
	// 		const currentVariations = variationData[randomVariationKey] || ['Loading...'];

	// 		// Function to update the placeholder message based on a counter
	// 		const updatePlaceholder = (currentCounter: number) => {
	// 			setPlaceholderMessage(currentVariations[currentCounter % currentVariations.length]);
	// 		};

	// 		// Set the first message of the variation immediately
	// 		updatePlaceholder(0);
	// 		setCounter(1); 

	// 		// Set an interval to cycle through the messages
	// 		intervalId = setInterval(() => {
	// 			setCounter(prevCounter => {
	// 				updatePlaceholder(prevCounter);
	// 				return prevCounter + 1;
	// 			});
	// 		}, 2500); // Change message every 2.5 seconds

	// 	} else {
	// 		// If not loading, reset to the default placeholder
	// 		setPlaceholderMessage('Type Your Question...');
	// 		setCounter(0);
	// 	}

	// 	// Cleanup function to clear the interval when the component unmounts or isIdeal changes
				//  	return () => {
				// 		if (intervalId) {
				// 			clearInterval(intervalId);
				// 		}
				// 	};

	useEffect(() => {
		if (typeof inputValue === 'string' && inputValue !== draftValue) {
			setDraftValue(inputValue);
		}
	}, [inputValue]);

	useEffect(() => {
		const recieveMessage = (inputMsg: any) => {
			const nextMessage = inputMsg?.message || '';
			setDraftValue(nextMessage);
			if (autocompleteRef.current) {
				autocompleteRef.current.focus();
			}
		};
		eventEmitter.on('publishMessageToInput', recieveMessage);
		return () => {
			eventEmitter.off('publishMessageToInput', recieveMessage);
		};
	}, []);

	// Send current input to parent handler and clear
	const handleSend = () => {
		if (draftValue && draftValue.trim() && isIdeal) {
			onSend(draftValue);
		}
		setDraftValue('');
	};

	const handleOnKeyDown = (event: any) => {
		if (
			isIdeal &&
			((!event.shiftKey && event.key === 'Enter') || (event.ctrlKey && event.key === 'Enter')) &&
			draftValue
		) {
			event.preventDefault();
			onEnter(draftValue);
			setDraftValue('');
		}
	};

	const switchSuggestion: any = (pageTitle: string) => {
		switch (pageTitle) {
			case 'UAE MT':
				return TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT;
			// case 'SpendWise':
			// 	return SPEND_WISE_SUGGESTIONS;
			default:
				return TOPLINE_AUTO_SUGGESTIONS_WHAT;
		}
	};

	const handleValueChange = (newValue: any) => {
		if (isIdeal) {
			setDraftValue(newValue);
			if (newValue) {
				let matchCriteria = switchSuggestion(pageTitle);
				const matchFound = matchCriteria?.filter((item: any) =>
					item.toLowerCase().startsWith(newValue.toLowerCase())
				);
				setOptions(matchFound);
			} else {
				setOptions([]);
			}
		}
	};

	const onSuggestionClick = (val: any) => {
		callLogEvent(
			'CLICKED_ON_NEW_DAILOG_CHATBOX_MORE_OPTIONS_' +
				val.toUpperCase().trim().replaceAll(' ', '_') +
				'_BUTTON',
			'clicked on more options button for chatbox'
		);
		setDraftValue(val);
		if (autocompleteRef.current) {
			autocompleteRef.current.focus();
		}
	};

	const handleSpeechToText = (data: any) => {
		setDraftValue(data.transcript);
		if (data.transcript && data.status && data.status === 'completed') {
			handleSend();
		}
	};

	const handleFileChange = async (event: any) => {
		const newFile: File = event.target.files[0];
		if (newFile) {
			setIsLoading(true);
			if (getFileSizeInMB(newFile) <= 10) {
				const bodyFormData = new FormData();
				bodyFormData.append('file', newFile!);

				const result = await uploadFile(
					bodyFormData,
					// localStorage.getItem('DataSource') === 'SpendWise'
				);

				if (result.docfile_id) {
					if (result.docfile_id === 'failure') {
						console.log('upload file failed');
						handleDocId('');
						setShowError(true);
						callLogEvent(
							'NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED',
							'File uploading failed'
						);
						setTimeout(() => {
							setShowError(false);
						}, 2000);
					} else {
						handleDocId(result.docfile_id);
						setShowSuccess(true);
						setTimeout(() => {
							setShowSuccess(false);
						}, 2000);
						console.log('File Uploaded successfully::', result.docfile_id);
						callLogEvent(
							'NEW_DIALOG_FILE_UPLOAD_ACTION_COMPLETE',
							'Attached file to the chat box window with file id: ' +
								result.docfile_id
						);
					}
				} else {
					console.log('Something went wrong please try again after sometime');
					handleDocId('');
					setShowError(true);
					callLogEvent(
						'NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED',
						'File uploading failed'
					);
					setTimeout(() => {
						setShowError(false);
					}, 2000);
				}
				setIsLoading(false);
			} else {
				setIsLoading(false);
				console.log('File size exceeded');
				handleDocId('');
				setShowError(true);
				callLogEvent(
					'NEW_DIALOG_FILE_UPLOAD_ACTION_FAILED',
					'File uploading failed due to high file size'
				);
				setTimeout(() => {
					setShowError(false);
				}, 2000);
			}
		}
	};
	const moreOptionsComponent = () => {
		return (
			<Grid
				item
				className={classes.moreOptions}
			>
				<Item className={classes.autoTextfield}>
					<Button
						id='demo-positioned-button'
						aria-controls={open ? 'demo-positioned-menu' : undefined}
						aria-haspopup='true'
						aria-expanded={open ? 'true' : undefined}
						onClick={handleClick}
						className={styles.moreOptions}
						// disabled={!isIdeal}
						disabled={
							restrictedUsers.includes(
								sessionStorage.getItem('emailid')?.toLowerCase()!
							)
								? restrictedUsers.includes(
										sessionStorage.getItem('emailid')?.toLowerCase()!
								  )
								: !isIdeal
						}
					>
						<img
							src={moreoptions}
							style={{height: '80px'}}
							alt='more options'
						/>{' '}
					</Button>
					<Menu
						id='demo-positioned-menu'
						aria-labelledby='demo-positioned-button'
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
						className={classes.menuStyles}
					>
						<MenuItem
							onClick={() => {
								onSuggestionClick('Frequently Asked Questions');
								handleClose();
							}}
						>
							FAQs
						</MenuItem>
						<MenuItem
							onClick={() => {
								onSuggestionClick('What');
								handleClose();
							}}
						>
							What
						</MenuItem>
						<MenuItem
							onClick={() => {
								onSuggestionClick('Generate Visuals');
								handleClose();
							}}
						>
							Generate Visuals
						</MenuItem>
						<MenuItem
							onClick={() => {
								onSuggestionClick('More');
								handleClose();
							}}
						>
							More
						</MenuItem>
					</Menu>
				</Item>
			</Grid>
		);
	};
	const handleAttachmentClick = () => {
		callLogEvent(
			'CLICKED_ON_NEW_DAILOG_ATTACHMENT_BUTTON',
			'clicked on attachment button to upload file'
		);
	};

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const NoMaxWidthTooltip = styled(({className, ...props}: TooltipProps) => (
		<Tooltip
			{...props}
			classes={{popper: className}}
		/>
	))({
		[`& .${tooltipClasses.tooltip}`]: {
			maxWidth: 'none',
		},
	});

	return (
		<>
			{hidden && (
				<div
					style={{width: '100%'}}
					className={classes.root}
				>
					<span className={styles.moreOptionsMobile}>
						<Grid
							container
							spacing={2}
							style={{
								background: '#fff',
								bottom: '13px',
								position: 'relative',
								margin: '0 auto',
								display: 'block',
								width: '70%',
							}}
						>
							{/* {moreOptionsComponent()} */}
						</Grid>
					</span>
					<div className={styles.inputFieldContainer} style={{width: '100%', boxSizing: 'border-box'}}>
						<Grid
							container
							direction='column'
							// spacing={1}
							className={styles.inputFieldGrid}
							style={{ width: '100%', margin: 0, padding: 0 }}
						>
							<Grid
								item
								className={styles.autoCompleteItem}
							>
								{/* Tip tooltip removed from InputField - tips are shown in the chat panel header */}
								<Item className={classes.autoTextfield}>
									<Autocomplete
										freeSolo
										options={options}
											inputValue={draftValue}
										onInputChange={(event, newInputValue) => {
											handleValueChange(newInputValue);
										}}
										// disabled={!isIdeal}
										disabled={
											isLoading
												? isLoading
												: restrictedUsers.includes(
														sessionStorage.getItem('emailid')?.toLowerCase()!
												  )
												? restrictedUsers.includes(
														sessionStorage.getItem('emailid')?.toLowerCase()!
												  )
												: !isIdeal
										}
										clearIcon={null}
										renderInput={(params) => (
											<TextField
												{...params}
												multiline
												minRows={isMobile ? 2 : 2}
												maxRows={isMobile ? 6 : 5}
												fullWidth
												variant='outlined'
												placeholder={placeholderMessage}
												inputRef={autocompleteRef}
												onKeyDown={handleOnKeyDown}
												InputProps={{
													...params.InputProps,
													endAdornment: (
														<InputAdornment
															position='end'
															sx={{
																alignSelf: 'center',
																height: '100%',
																mr: 0,
																flexShrink: 0,
															}}
														>
															{isIdeal && !isLoading ? (
																<Box
																	sx={{
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'center',
																		gap: {xs: 0.5, sm: 0.75},
																		flexShrink: 0,
																		pl: 0.5,
																		height: '100%',
																	}}
																>
																	<SpeechToText
																		isDisable={!isIdeal && !isLoading}
																		handleChange={(inputData) =>
																			handleSpeechToText(inputData)
																		}
																	/>
																	<IconButton
																		onClick={handleSend}
																		disabled={isLoading}
																		size='small'
																		sx={{
																			width: {xs: 34, sm: 38},
																			height: {xs: 34, sm: 38},
																			p: 0.5,
																			flexShrink: 0,
																		}}
																	>
																		<img
																			src={MessageSent}
																			alt='Start New Chat'
																			className={styles.sendIcon}
																		/>
																	</IconButton>
																</Box>
															) : (
																<>
																	{/* <CircularProgress
                              style={{
                                width: "20px",
                                height: "20px",
                                marginRight: "10px",
                              }}
                            /> */}
																	{/* {(!isIdeal && isLoading)?null:(setIsLoading(false),setPlaceholderMessage("Type your question..."))} */}
																	{/* {handlePlaceHolderMessage} */}
																</>
															)}
														</InputAdornment>
													),
												}}
												// sx={{
												// 	'& .MuiOutlinedInput-root': {
												// 		borderRadius: '8px',
												// 		border: '1px solid #C0C0C0',
												// 		background: ' #FBFCFE',
												// 		padding: '0px 8px 0px 16px',
												// 		fontSize: '12px',
												// 		minHeight: '10px',
												// 	},
												// }}
												sx={{
													'& .MuiOutlinedInput-root': {
														borderRadius: '10px', 
														border: '1px solid #E6E6E6', // neutral soft border
																										background: '#FBFCFE', // subtle off-white
																									padding: '0px 10px',
																										fontSize: '13px', // compact font
																									minHeight: '52px',
																										maxHeight: '160px',
																										transition: 'all 0.18s ease',
																										boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
																										minWidth: '200px',
																										alignItems: 'center',

																										'&:hover': {
																											borderColor: '#D0D5DD',
																											boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
																										},

																										'&.Mui-focused': {
																											borderColor: '#5B7CFF',
																											boxShadow: '0 0 0 3px rgba(91,124,255,0.06)',
																										},

																																							'& .MuiInputBase-input': {
																																								padding: '10px 0',
																																								lineHeight: '1.4',
																																								color: '#111827',
																																								overflowY: 'auto',
																																								minWidth: 0,
																																							}
																								},
																								'& .MuiInputAdornment-root': {
																									marginTop: 0,
																									maxHeight: 'none',
																								},
																								'& .MuiAutocomplete-endAdornment': {
																									display: 'none',
																								},
																								width: '100%',
												}}
											/>
										)}
										ListboxProps={{
											sx: {
												fontSize: '0.8rem',
												'& .MuiAutocomplete-option': {
													fontSize: '0.8rem',
												},
											},
										}}
									/>
								</Item>
							</Grid>
							{/* <span className={styles.moreOptionsWeb}>
								{moreOptionsComponent()}
							</span> */}
						</Grid>
					</div>
					{/* <div
						style={{
							textAlign: 'center',
							fontSize: '12px',
							position: 'relative',
							bottom: '15px',
						}}
					>
						{showError && (
							<span className='errorMsg'>
								Something went wrong please try again after sometime.
								<br />
							</span>
						)}
						{showSuccess && (
							<span className='successMsg'>
								File Uploaded scuccessfully.
								<br />
							</span>
						)}
						AI Generated Response, Please Validate For Accuracy
					</div> */}
				</div>
			)}
		</>
	);
};

export default InputField;
